import { GondolaIcon } from './GondolaIcon';

/**
 * author: Austin Andrews
 * id 9FE486F5-20A0-4CB5-A820-93AD82F52EB6
 * name gondola
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gondola.svg
 * tags
 * - Transportation + Other 
 */
export const CableCarIcon = GondolaIcon;
export default CableCarIcon